// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"ea0865f6","109":"cc76408a","412":"dede6852","418":"e97c6ef2","531":"8cc0e774","706":"0c5c9741","981":"424aec21"}[chunkId] + ".chunk.js";
};